import Vue from 'vue'
import App from './App.vue'
import 'amfe-flexible'
// 引入重置样式表
import '@/assets/css/reset.css'
import less from 'less'
Vue.use(less)
import { Dialog } from 'vant';
//导入所有组件。
import Vant from 'vant';
import { AddressEdit } from 'vant';
import { Area } from 'vant';

Vue.use(Area);
Vue.use(AddressEdit);
import 'vant/lib/index.css';
import { Swipe, SwipeItem } from 'vant';
//main.js
Vue.prototype.$eventBus = new Vue()
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Vant);
Vue.use(Dialog);
// 引入路由文件
import router from '@/router/index.js';
// 引入Vuex store
import store from '@/store/index.js';
// 引入vant 提供过的懒加载
import { Lazyload } from 'vant';
Vue.use(Lazyload);
import { Divider } from 'vant';
Vue.use(Divider);
import { Toast } from 'vant';
Vue.use(Toast);
import { Popup } from 'vant';

Vue.use(Popup);
import {Loading} from 'vant';
Vue.use(Loading);

// 添加全局 loading 方法
Vue.prototype.$loading = {
  show(options = {}) {
    Toast.loading({
      message: options.message || '加载中...',
      forbidClick: true,
      duration: 0
    });
  },
  hide() {
    Toast.clear();
  }
};
import { Field } from 'vant';
Vue.use(Field);
import { Button } from 'vant';
Vue.use(Button);
import { Icon } from 'vant';
Vue.use(Icon);
import { NavBar } from 'vant';
Vue.use(NavBar);
Vue.config.productionTip = false


//全局过滤器
Vue.filter('moneyFlrmat',function(value){
    return `￥${value.toFixed(2)}元`

})


new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
